import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'portalRequestType',
})
export class PortalRequestTypePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 0:
        return 'New User';
      case 1:
        return 'Referral - Update';
      case 2:
        return 'Work Comp - Update';
      default:
        return 'Unknown';
    }
  }
}
